// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3jihs","title":"BackImages_title__1Pq9t","images":"BackImages_images__CuPfc"};